import { Box, Typography, Container } from '@mui/material';
import { useAuth } from 'src/context/auth/AuthContext';
import TransactionStatusTracker from 'src/components/teacher/TransactionStatusTracker';

export default function TransactionStatusTrackerPage() {
  const { user } = useAuth();

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Transaction Status
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Monitor pending transactions and student responses
        </Typography>
        
        <TransactionStatusTracker
          teacherId={user?.id || ''}
          classIds={[]}
        />
      </Box>
    </Container>
  );
}